import React from "react";

interface ChatTextAnimationProps {
  className?: string;
  children: string;
  duration?: number; // total duration for one cycle
}

export default function ChatTextAnimation({
  className,
  children,
  duration = 3,
}: ChatTextAnimationProps) {
  return (
    <span
      className={className}
      style={{
        background: "linear-gradient(90deg, #888, #bbb, #fff, #888)",
        backgroundSize: "200% 100%",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        display: "inline-block",
        animation: `wave ${duration}s linear infinite`,
      }}
    >
      {children}
      <style>
        {`
          @keyframes wave {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `}
      </style>
    </span>
  );
}
